import router from "../../router";
import tree from "../js/tree";
import { Message,Loading } from 'element-ui';
import data from "../js/tree";
import store from "../../store";
var menu_tree=JSON.parse(JSON.stringify(tree))

var getMenuList=function () {
  let menu_list=[];

  function getList(list=[]) {
    list.map(ret=>{

      //      id      varchar(20)          null comment '顶级路由id',
      //     label   varchar(20)          null comment '名称',
      //     icon    varchar(130)         null comment '图标',
      //     path    varchar(80)          null comment '路由',
      //     pid     varchar(20)          null comment '顶级路由id',
      //     is_menu tinyint(1) default 1 null comment '判断是否为目录菜单（0=不是，1=是）'
      let obj_item={};
      obj_item.id=ret.id;
      obj_item.label=ret.label;
      obj_item.icon=ret.icon;
      obj_item.path=ret.path||'';
      obj_item.pid=ret.pid;
      obj_item.is_menu=ret.is_menu?1:0;
      menu_list.push(obj_item)
      ret.children&&ret.children.length&&getList(ret.children);
    })
  }
  getList(menu_tree)
  return menu_list;
}

var getMenuList2=function () {
  let menu_list=[];
  function getList(list=[]) {
    list.map(ret=>{
      let obj_item={};
      obj_item.id=ret.id;
      obj_item.label=ret.label;
      obj_item.icon=ret.icon;
      obj_item.path=ret.path||'';
      obj_item.pid=ret.pid;
      obj_item.is_menu=ret.is_menu?1:0;
      menu_list.push(obj_item)
      ret.children&&ret.children.length&&getList(ret.children);
    })
  }
  getList(ERP.getStore().__USER_MENU_LIST__)
  return menu_list;
}

/**
 * ERP工程主控制类
 * 扩展添加了vue实例 __ERP__ 并挂载进了全局里
 */
export default class ERP {
  constructor() {

  }

  /**
   * 初始化参数配置
   */
  static initAPP(){
    __HTTP__.get('admin/config/getConfig').then(({data}=ret)=>{
      if(data&&data.code&&data.data){
        data.data.appLogo&&(data.data.appLogo=data.data.appLogo.replace('\\','/'))
        console.log(data.data)
        ERP.setStore('__APP_CONFIG__',data.data)
      }
    })
  }
  /*******************************路由页面模块*************************************/
  /**
   * 初始化目录
   * @param page
   * @returns {{path, component: (function(): Promise<*>), name}[]}
   */
  static initPage(page=[]){
    // var that=this;
    // return page.map(ret=>{
    //   let _pg={
    //     path: ret.path,
    //     name: ret.name,
    //     component: () => import('@/'+ret.component),
    //   }
    //   ret.children&&ret.children.length&&(_pg.children=that.initPage(ret.children))
    //   return _pg;
    // })
  }

  /**
   * 路由权限检测器
   * @param router
   */
  static vuetifyPage(router){
    router.beforeEach((to, from, next) => {
      //console.log("路由权限检测器==》",to.path)
      let menu_list=getMenuList();
      let menu_item=menu_list.filter(ret=>{ return ret.path===to.path })

      if(menu_item&&menu_item.length){
        let appName=ERP.getStore().__APP_CONFIG__.appName;
        let label=menu_item[0].label;
        document.title = (appName?(appName+"-"):"")+(label || "");
        ERP.setStore('__PAGE_OPT__',menu_item[menu_item.length-1])
      }
      //检测体
      if(to.path!=='/login'&&to.path!=='/'){
        let ids=menu_item.map(ret=>{return ret.id}).join(',');
        if(menu_item.length){
          __HTTP__.post("admin/isMenuAble",{ids:ids}).then(({data}=ret)=>{
            if(data){
              if(data&&data.code){
                next();
              }else if(data===306) {
                window.__ERP__.$router.push({name:"login"})
              }
            }else {
              Message.warning("权限不足")
              ERP.hideLoading()
              ERP.navigateBack();
            }
          })
        }else {
          next();
        }
      }else {
        next();
      }
    });
  }

  /**
   * 跳转页面
   * @param url
   * @param callback
   */
  static navigateTo(url="/",callback){
    window.__ERP__.$router.push(url,callback)
  }

  /**
   * 页面跳转返回
   * @param delta
   * @param callback
   */
  static navigateBack(delta=-1,callback){
    window.__ERP__.$router.go(delta)
    typeof callback==="function"&&callback()
  }

  /**
   * 获取页面信息
   * @returns {Route}
   */
  static getPages(){
    return window.__ERP__.$route
  }
  /*******************************路由页面模块*************************************/

  /**
   * 拉取权限菜单
   */
  static getMenuAllTree(){
    window.__MENU_LIST__=ERP.getLocalTree()
    ERP.setStore('__MENU_LIST__',window.__MENU_LIST__);
    __HTTP__.get("admin/getMenuAllTree").then(ret=>{
      if(ret){
        if(ret===306){
          Message.warning('菜单请求异常')
        }else {
          let data=ret.data
          if(data.code&&data.data==='admin'){
            window.__MENU_LIST__=ERP.getLocalTree()
            console.log('本地')
          }else {
            data.code&&typeof data.data==='object'&&(window.__MENU_LIST__=data.data)
            console.log('网络权限')
          }
          ERP.setStore('__MENU_LIST__',window.__MENU_LIST__);
        }
      }
    })
  }

  /**
   * 获取很低权限菜单
   * @returns {*[]}
   */
  static getLocalTree () {
    function getList(list=[]) {
      list.map(ret=>{
        ret.id=ret.id+'';
        ret.pid=ret.pid+'';
        ret.children&&ret.children.length&&(ret.children=getList(ret.children));
        return ret;
      })
      return list;
    }
    return getList(JSON.parse(JSON.stringify(menu_tree)))
  }

  /**
   * 获取状态
   * @returns {*}
   */
  static getStore(key=null){
    if(key){
      return store.state[key];
    }else {
      return store.state;
    }
  }
  /**
   * 设置状态
   * @param key
   * @param val
   */
  static setStore(key,val){
    store.commit(key,{key,val})
  }

  /**
   * 获取状态
   * @returns {*}
   */
  static getLocalStore(key=null){
    if(key){
      let data=window.localStorage.getItem(key)
      if(data){
        try {
          data=JSON.parse(data);
        }catch (e) {

        }
      }
      return data;
    }else {
      return null;
    }
  }
  /**
   * 设置状态
   * @param key
   * @param val
   */
  static setLocalStore(key,val){
    window.localStorage.setItem(key,JSON.stringify(val))
  }

  /**
   * 加载
   */
  static showLoading(){
    ERP.setStore('__APP_LOADING__',Loading.service({
      target:"#ti-right",
      // background:"rgba(0,0,0,0.5)"
    }));
  }

  /**
   * 隐藏加载
   */
  static hideLoading(){
    ERP.getStore().__APP_LOADING__&&ERP.getStore().__APP_LOADING__.close();
    ERP.setStore('__APP_LOADING__',{})
  }

  /**
   * 权限id数组
   * @returns {[]|default.user_permission_ids|*|*[]}
   */
  static getTreePermissionIds(isLoad=false){
    if(ERP.getStore().user_permission_ids.length&&!isLoad){
      return ERP.getStore().user_permission_ids;
    }else {
      setTimeout(function(){
        let list=getMenuList2();
        ERP.setStore('user_permission_ids',list.map(ret=>{return ret.id+'' }))
        return list;
      },800)
    }
  }

  /**
   * 判断权限
   * @param id
   * @returns {boolean}
   */
  static isPermission(id){
    return ERP.getTreePermissionIds().indexOf(id+'')!==-1
  }

  /**
   * 判断权限
   * @param ids
   * @returns {boolean}
   */
  static isPermissions(ids=[]){
    let _ids=ids.map(ret=>ret+'')
    let p_ids=ERP.getTreePermissionIds();
    let sb=new Set(p_ids)
    let intersect = _ids.filter(x => sb.has(x));
    return !!intersect.length;
  }

  static isProjects(id){

  }

  /**
   * 提示
   * @param type 类型 success/warning/info/error
   * @param title 名称
   */
  static showToast({type='info',title=''}){
    Message[type](title);
  }

  /**
   * 复制
   * @param data 复制的数据
   * @param callBack
   */
  static copy(data,callBack){
    // navigator clipboard 需要https等安全上下文
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard 向剪贴板写文本
      navigator.clipboard.writeText(data).then(function() {
        typeof callBack==='function'&&callBack("复制成功");
      }, function() {
        typeof callBack==='function'&&callBack("复制失败");
      });
    }else {
      let input = document.createElement("input");
      input.value = data;
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length);
      document.execCommand('Copy');
      document.body.removeChild(input);
      typeof callBack==='function'&&callBack("复制成功！");
    }
  }

  static getRequest({url,data},success,error){
    __HTTP__.getRequest({url,data},success,error)
  }
  static postRequest({url,data},success,error){
    __HTTP__.postRequest({url,data},success,error)
  }
  static reJson(val ){
    return JSON.parse(JSON.stringify(val))
  }


}



// WEBPACK FOOTER //
// ./src/assets/lib/ERP.js